// 获取动画帧函数自动适配
if (!window.requestAnimationFrame) {
    window.requestAnimationFrame =
        window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function (callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
}
// 获取当前位置
const position = (el) => {
    return el === window
        ? document.documentElement.scrollTop ||
            document.body.parentNode.scrollTop ||
            document.body.scrollTop
        : el.scrollTop;
};
// 滚动方法
const move = (el, d) => {
    if (el === window) {
        window.scrollTo(0, d);
        // document.documentElement.scrollTop = d;
        // (document.body.parentNode as HTMLElement).scrollTop = d;
        // document.body.scrollTop = d;
    }
    else {
        el.scrollTop = d;
    }
};
/**
 * 向上滚动到特定位置，带动画效果
 * @param el 滚动的dom元素
 * @param to 终点位置（scrollTop值），默认置顶
 * @param duration 时长
 * @param callback 回调函数
 */
export function scrollTop(el, to = 0, duration = 500, callback) {
    // 获取当前位置
    const from = position(el);
    // 计算步长
    const difference = Math.abs(from - to);
    const step = Math.ceil((difference / duration) * 50);
    const scroll = (start, end, step) => {
        if (start === end) {
            callback && callback();
            return;
        }
        // 计算滚动距离
        let d = start + step > end ? end : start + step;
        if (start > end) {
            d = start - step < end ? end : start - step;
        }
        move(el, d);
        // 请求下一个动画帧
        window.requestAnimationFrame(() => scroll(d, end, step));
    };
    scroll(from, to, step);
}
